/**
 * Predicate for a PERSISTENT authorization denial from the API — the session's
 * user is not a member of the project (AgentSessionService authorizes every RPC
 * against project membership and disables service-level access). The API's ACL
 * layer (quickdraw-core) throws "Insufficient permissions"; a missing/invalid
 * identity throws "Authentication required".
 *
 * This is deliberately DISTINCT from `AgentConnection.looksLikeAuthError` (stale
 * token / expired session), which a token refresh CAN fix. A permission denial
 * cannot be fixed by retrying or refreshing — the runner parks cleanly instead
 * of crash-looping the process (which would burn the 3× supervisor restarts on
 * an outcome that never changes). See `session-runner.ts` connect().
 */
export function isPermissionDeniedError(err: unknown): boolean {
  const message = err instanceof Error ? err.message : String(err);
  return /insufficient permissions|authentication required/i.test(message);
}
